import { ReactElement, useContext } from "react";
import { Anchor } from "@twilio-paste/core/anchor";
import { Box } from "@twilio-paste/core/box";
import { Heading } from "@twilio-paste/core/heading";
import { Text } from "@twilio-paste/core/text";

import { types } from "./definitions";
import styles from "./PreChatHeader.module.css";
import landingIllustration from "../../assets/landing-illustration.svg";
import { useWiseOwlContext } from "../../hooks";

const PreChatHeader = ({
  anchorProps,
  hasImage = true,
  headerText,
  subText,
}: types.PreChatHeaderProps): ReactElement => {
  return (
    <Box as="div">
      {hasImage && (
        <Box
          as="img"
          src={landingIllustration}
          alt="chat box header"
          className={styles.preChatImage}
          height="12rem"
          width="12rem"
        />
      )}
      <Heading as="h2" variant="heading20" marginBottom="space0">
        {headerText}
      </Heading>
      <Text as="p" display={"flex"}>
        {subText}

        {anchorProps && (
          <Anchor
            href={anchorProps.href}
            onClick={anchorProps.onClick}
            showExternal={anchorProps.showExternal}
            marginLeft="space20"
          >
            {anchorProps.children}
          </Anchor>
        )}
      </Text>
    </Box>
  );
};

export default PreChatHeader;
